import { API } from '@/api';
import { buildIsReadFilter } from '@/utils/filters';

export const classes = {
  clearAll: 'text-red-2',
};

export const CLEAR_READ_FILTER = buildIsReadFilter(true);

export function readAllNotifications() {
  return API.Notifications.updateAllNotifications({ isRead: true });
}

export function clearReadNotifications() {
  return API.Notifications.removeAllNotifications(CLEAR_READ_FILTER);
}

export function clearAllNotifications() {
  return API.Notifications.removeAllNotifications();
}
